import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { vignetteStylesheetsList_template } from "../components/templates/vignetteStylesheetsList_template";

declare var ko: any;
declare var page: any;

export class vignette_stylesheets extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: vignetteStylesheetsList_template;
    protected timer;

    protected getModuleName() {
        return "vignette_stylesheets";
    }

    buildContent(): Array<Element> {
        this.elementsList = new vignetteStylesheetsList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Vignette Stylesheets");

        return [this.elementsList.build()];
    }

    public fillPage(): void {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.elementsList.setIdBrand(idBrand);
        }
        this.getfilterReference();
    }

    public addStylesheet() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.saveViewModule(this.getMemoryViewModel());
        page(`/brand/${this.getVnAppZone().app.params.idBrand}/categorization/vignette-stylesheets/add/`);
    }

    public viewStylesheet(idStylesheet: number) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.saveViewModule(this.getMemoryViewModel());
        page(`/brand/${this.getVnAppZone().app.params.idBrand}/categorization/vignette-stylesheets/view/${idStylesheet}`);
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected filterDropdownOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterByUrl() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    public getfilterReference(): void {
        if ("getfilterReference" in this.XHRHdls) {
            this.XHRHdls["getfilterReference"].cancelAndReset();
        }

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/vignette-stylesheets/references';
        this.XHRHdls['getfilterReference'] = new XMLHttpRequestHandler(usrReq_url, [], this);
        this.XHRHdls['getfilterReference'].onReadyStateFunction = this.onFilterReferenceRequestReturn;
        this.XHRHdls['getfilterReference'].execute();
    }

    protected onFilterReferenceRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setBrands(responseParsed.brands);
                obj.filterList();
            });
        }
    }

    protected filterList() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = `/api/brand/${idBrand}/vignette-stylesheets/get/`;
        this.timer = new Date().getTime();
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'vignette_stylesheets');
    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.updateViewModelFromPath();
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    protected updateList(responseParsed: any) {
        this.elementsList.setStylesheets(responseParsed.data);

        let execTime = Math.round((new Date().getTime() - this.timer) / 1000 * 100) / 100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected getMemoryViewModel() {
        let templateViewModel = this.elementsList.getTemplateViewModel();
        return templateViewModel;
    }
}



// WEBPACK FOOTER //
// ./js/modules/vignette_stylesheets.ts